<div>
    <!-------------------------------------- Toutes -------------------------------------->
    <pannel [title]="'Toutes'" [expandable]="true" [folded]="true">
        <table mat-table class="communicationmutuelle" [dataSource]="toutesOperationsTable">
            <!-- Id -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Id : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.id}} </td>
            </ng-container>
            <!-- communicationMutuelleInfoId -->
            <ng-container matColumnDef="communicationMutuelleInfoId">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell"></th>
                <td mat-cell *matCellDef="let communicationMutuelle">
                    <mat-checkbox color="primary" [(ngModel)]="communicationMutuelle.communicationMutuelleInfoId"></mat-checkbox>
                </td>
            </ng-container>
            <!-- selected -->
            <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell"></th>
                <td mat-cell *matCellDef="let communicationMutuelle">
                    <mat-checkbox color="primary" [(ngModel)]="communicationMutuelle.selected"
                    	(change)="onChangeToutes(communicationMutuelle)"></mat-checkbox>
                </td>
            </ng-container>
            <!-- Information -->
            <ng-container matColumnDef="information">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Document / Information : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.information}} </td>
            </ng-container>
            <!-- Emplacement -->
            <ng-container matColumnDef="emplacement">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Archivage / Emplacement : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.emplacement}} </td>
            </ng-container>
            <!-- Fournisseur -->
            <ng-container matColumnDef="fournisseur">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Fournisseur : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.fournisseur}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCommunicationMutuelle"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCommunicationMutuelle;"></tr>
        </table>
    </pannel>

    <!----------------------------- Travaux d'ordre électrique ------------------------------->
    <pannel [title]="'Travaux d&rsquo;ordre &eacute;lectrique'" [expandable]="true" [folded]="true">
        <table mat-table class="communicationmutuelle" [dataSource]="travauxElectriquesTable">
            <!-- Id -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Id : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.id}} </td>
            </ng-container>
            <!-- selected -->
            <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell"></th>
                <td mat-cell *matCellDef="let communicationMutuelle">
                    <mat-checkbox color="primary" [(ngModel)]="communicationMutuelle.selected" 
                    	(change)="onChangeTravauxElectrique(communicationMutuelle)"></mat-checkbox>
                </td>
            </ng-container>
            <!-- Information -->
            <ng-container matColumnDef="information">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Document / Information : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.information}} </td>
            </ng-container>
            <!-- Emplacement -->
            <ng-container matColumnDef="emplacement">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Archivage / Emplacement : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.emplacement}} </td>
            </ng-container>
            <!-- Fournisseur -->
            <ng-container matColumnDef="fournisseur">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Fournisseur : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.fournisseur}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCommunicationMutuelle"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCommunicationMutuelle;"></tr>
        </table>
    </pannel>

    <!------------------------- Travaux sur équipements hydrauliques -------------------------->
    <pannel *ngIf="travauxEquipementsHydrauliquesTable.data && travauxEquipementsHydrauliquesTable.data.length &gt; 0" [title]="'Travaux sur &eacute;quipements hydrauliques'" [expandable]="true" [folded]="true">
        <table mat-table class="communicationmutuelle" [dataSource]="travauxEquipementsHydrauliquesTable">
            <!-- Id -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Id : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.id}} </td>
            </ng-container>
            <!-- selected -->
            <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell"></th>
                <td mat-cell *matCellDef="let communicationMutuelle">
                    <mat-checkbox color="primary" [(ngModel)]="communicationMutuelle.selected"
                                  (change)="onChangeTravauxEquipementsHydrauliques(communicationMutuelle)"></mat-checkbox>
                </td>
            </ng-container>
            <!-- Information -->
            <ng-container matColumnDef="information">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Document / Information : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.information}} </td>
            </ng-container>
            <!-- Emplacement -->
            <ng-container matColumnDef="emplacement">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Archivage / Emplacement : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.emplacement}} </td>
            </ng-container>
            <!-- Fournisseur -->
            <ng-container matColumnDef="fournisseur">
                <th mat-header-cell *matHeaderCellDef class="communicationmutuelle-header-cell">Fournisseur : </th>
                <td mat-cell *matCellDef="let communicationMutuelle"> {{communicationMutuelle.fournisseur}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCommunicationMutuelle"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCommunicationMutuelle;"></tr>
        </table>
    </pannel>
</div>